import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { AuthOnboardingLayout } from '../../components/login-v2/AuthShell';
import AuthBackHeader from '../../components/login-v2/AuthBackHeader';
import AuthMascot from '../../components/login-v2/AuthMascot';
import AuthPrimaryButton from '../../components/login-v2/AuthPrimaryButton';
import AgreementRow from '../../components/login-v2/AgreementRow';
import PolicyScrollPopup from '../../components/common/PolicyScrollPopup';
import { AuthContext } from '../../context/AuthContext';
import { POLICY_TYPES } from '../../content/policies';
import { isSignupOnboarding } from './signupStorage';

function hasStoredAuth() {
  return Boolean(localStorage.getItem('accessToken') && localStorage.getItem('refreshToken'));
}

export default function LoginV2TermsPage() {
  const navigate = useNavigate();
  const { useAccessToken } = useContext(AuthContext);
  const accessToken = useAccessToken();

  const [age, setAge] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [service, setService] = useState(false);
  const [policyType, setPolicyType] = useState(null);

  const allAgreed = age && privacy && service;
  const canProceed = useMemo(() => allAgreed, [allAgreed]);

  useEffect(() => {
    if (!accessToken && !hasStoredAuth()) {
      navigate('/login', { replace: true });
      return;
    }
    if (accessToken && !isSignupOnboarding()) {
      navigate('/playground', { replace: true });
    }
  }, [accessToken, navigate]);

  const toggleAll = () => {
    const next = !allAgreed;
    setAge(next);
    setPrivacy(next);
    setService(next);
  };

  return (
    <>
      <AuthOnboardingLayout
        header={<AuthBackHeader onBack={() => navigate('/login')} />}
        actions={
          <AuthPrimaryButton disabled={!canProceed} onClick={() => navigate('/login-v2/nickname')}>
            다음
          </AuthPrimaryButton>
        }
      >
        <div className="mt-6 px-[10px]">
          <AuthMascot />
          <h1 className="mt-5 font-['Pretendard'] text-[22px] font-bold leading-[1.32] text-black">
            야옹상회의 <span className="text-primary-purple-01">이용약관</span>에
            <br />
            <span className="text-primary-purple-01">동의</span>가 필요해요!
          </h1>
        </div>

        <div className="mt-12 flex flex-col gap-5 px-[10px]">
          <AgreementRow label="약관 전체동의" checked={allAgreed} onToggle={toggleAll} bold size="lg" />
          <div className="h-px w-full bg-gray02" />
          <AgreementRow label="[필수] 만 14세 이상입니다." checked={age} onToggle={() => setAge((v) => !v)} />
          <AgreementRow
            label="[필수] 개인정보 수집 및 이용동의"
            checked={privacy}
            onToggle={() => setPrivacy((v) => !v)}
            showArrow
            onArrowClick={() => setPolicyType(POLICY_TYPES.COLLECTION)}
          />
          <AgreementRow
            label="[필수] 서비스 이용 약관동의"
            checked={service}
            onToggle={() => setService((v) => !v)}
            showArrow
            onArrowClick={() => setPolicyType(POLICY_TYPES.SERVICE)}
          />
        </div>
      </AuthOnboardingLayout>

      <PolicyScrollPopup open={!!policyType} type={policyType} onClose={() => setPolicyType(null)} />
    </>
  );
}
